import {Injectable} from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {finalize, tap} from 'rxjs/operators';
import {NgxSpinnerService} from "ngx-spinner";
import {Router} from '@angular/router';
import {ConfirmDialogService} from './confirm-dialog.service';
import {AuthService} from "./auth.service";

@Injectable({
	providedIn: 'root'
})
export class InterceptorService {
	count = 0;

	constructor(
		private spinner: NgxSpinnerService,
		public router: Router,
		public dialog: ConfirmDialogService,
		private authService: AuthService,
	) {
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		this.spinner.show()
		this.count++;

		return next.handle(req)
			.pipe(
				tap(
					(event) => {
					},
					(error: any) => {
						if (error.status !== 401 && error.status !== 403 && error.status !== 999) return;

						const isLoggingOut = localStorage.getItem('isLoggingOut') === 'true';
						if(error.error == "OUT_OF_SIMU"){
							this.dialog.confirmThis("", "Vous n'avez plus de simulation disponibles. Vous ne pouvez plus modifier les données de cette simulation.", "alert", "", () => {
								history.back();
							}, () => {
							});
						}
						if (!isLoggingOut) {
							this.dialog.confirmThis("", "Votre session a expiré. Merci de vous re-connecter.", "alert", "", () => {
								this.authService.triggerLogout();
							}, () => {
							});
						}
					}
				),
				finalize(() => {
					this.count--;
					if (this.count == 0) this.spinner.hide();
				})
			);
	}
}
